var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenterBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.667-3.667h29.333v29.333H-3.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.528 16.793c0 .844-.648 1.54-1.528 1.54-.856 0-1.54-.684-1.54-1.54 0-.867.684-1.527 1.54-1.527.868 0 1.528.672 1.528 1.527zm-1.54-13.126c-2.164 0-3.642 1.405-4.192 3.043l2.004.843c.269-.819.904-1.809 2.2-1.809 1.98 0 2.371 1.858 1.674 2.848-.66.941-1.796 1.577-2.395 2.64-.477.844-.379 1.821-.379 2.42h2.224c0-1.136.086-1.369.27-1.723.476-.88 1.356-1.296 2.285-2.652.831-1.223.513-2.885-.025-3.765-.623-1.026-1.857-1.845-3.666-1.845zm8.568-1.223H2.444v17.112h17.112V2.444m0-2.444C20.9 0 22 1.1 22 2.444v17.112C22 20.9 20.9 22 19.556 22H2.444A2.452 2.452 0 010 19.556V2.444C0 1.1 1.1 0 2.444 0h17.112z",
    fill: "#232323",
    fillRule: "nonzero"
  }))));
}
export default SvgHelpCenterBlack24Dp;